"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import { Fraunces } from "next/font/google";
import { useDesktopAnimations } from "@/lib/breakpoints";

// Only used by this footer wordmark. It's the largest font file on the site
// (~43 KB), so don't <link rel="preload"> it on every page's critical path —
// it still loads normally once the footer text is laid out.
const fraunces = Fraunces({
  subsets: ["latin"],
  preload: false
});
export default function BrandReveal() {
  const $ = _c(10);
  const isDesktop = useDesktopAnimations();
  const reducedMotion = useReducedMotion();
  const rootRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      margin: "100px 0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const inView = useInView(rootRef, t0);
  const animateSweep = isDesktop && !reducedMotion && inView;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="w-full h-auto block m-0 p-0" viewBox="0 0 620 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><text x="0" y="98%" textLength="620" lengthAdjust="spacingAndGlyphs" dominantBaseline="auto" textAnchor="start" stroke="currentColor" strokeWidth="1" paintOrder="stroke fill" style={{
        fontFamily: fraunces.style.fontFamily,
        fontSize: "115px"
      }} className="fill-neutral-200 stroke-neutral-200 dark:fill-neutral-800 dark:stroke-neutral-800">{"The Dezine"}</text></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== animateSweep) {
    t2 = animateSweep ? {
      maskPosition: ["100% 0%", "-100% 0%"]
    } : {
      maskPosition: "0% 0%"
    };
    t3 = animateSweep ? {
      duration: 4.5,
      repeat: Infinity,
      ease: "linear"
    } : {
      duration: 0
    };
    $[2] = animateSweep;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      WebkitMaskImage: "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.2) 35%, #000 50%, rgba(0,0,0,0.2) 65%, transparent 100%)",
      maskImage: "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.2) 35%, #000 50%, rgba(0,0,0,0.2) 65%, transparent 100%)",
      WebkitMaskSize: "200% 100%",
      maskSize: "200% 100%"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="w-full h-auto block m-0 p-0" viewBox="0 0 620 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><text x="0" y="98%" textLength="620" lengthAdjust="spacingAndGlyphs" dominantBaseline="auto" textAnchor="start" stroke="currentColor" strokeWidth="1" paintOrder="stroke fill" style={{
        fontFamily: fraunces.style.fontFamily,
        fontSize: "115px"
      }} className="fill-neutral-500 stroke-neutral-500 dark:fill-neutral-400 dark:stroke-neutral-400">{"The Dezine"}</text></svg>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3) {
    t6 = <div ref={rootRef} className="w-full overflow-hidden p-0 m-0 select-none leading-none"><div className="relative w-full">{t1}<motion.div className="absolute inset-0 w-full h-full pointer-events-none" animate={t2} transition={t3} style={t4}>{t5}</motion.div></div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}